function parseJSONParams(paramsAsString, defaultValue) {
  try {
    return JSON.parse(paramsAsString);
  } catch (err) {
    return defaultValue;
  }
}

function convertType(value, defaultValue) {
  if (value === undefined || value === null) {
    return defaultValue;
  }
  if (typeof defaultValue === 'string') {
    return value || defaultValue;
  }
  if (typeof defaultValue === 'boolean') {
    return !!value;
  }
  if (typeof defaultValue === 'number') {
    return value;
  }
  if (typeof defaultValue === 'object') {
    return parseJSONParams(value, defaultValue);
  }
  return value;
}

export function createRemoteConfigSnapshotNormalizer(
  defaultValues,
  enableLogger = false
) {
  return function (snapshot) {
    if (enableLogger) {
      console.log("Normalizer: param names", Object.keys(defaultValues));
      console.log("Normalizer: snapshot", snapshot);
    }

    const remoteConfig = Object.keys(defaultValues).reduce(
      (convertedData, paramName) => {
        // eslint-disable-next-line no-param-reassign
        convertedData[paramName] = convertType(
          snapshot[paramName],
          defaultValues[paramName]
        );
        return convertedData;
      },
      {}
    );

    if (enableLogger) {
      console.log("Normalizer: normalized remoteConfig", remoteConfig);
    }

    return { remoteConfig, snapshot };
  };
}
